var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tbody',[_c('tr',[_c('th',[_vm._v(" "+_vm._s(_vm.displayName)+" ")]),_c('td',[_c('CheckBox',{model:{value:(_vm.checkModel),callback:function ($$v) {_vm.checkModel=$$v},expression:"checkModel"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }